import React from 'react';
import Slider from 'react-slick';

import Device5 from '../images/DSC02550 Large.jpg';
import Device from '../images/UBIcomputer.png';
import Device3 from '../images/DSC02608 Large.jpg';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function AboutUsIntro() {
    const settings = {
        infinite: true,
        speed: 500,
        fade: false,
        arrows: false,
        dots: true,
        autoplay: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <section className="relative overflow-hidden py-12 sm:py-16 lg:py-20">
            <div className="mt-12"></div>
            <div className="relative mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                <div className="relative overflow-hidden rounded-3xl border border-gray-800 bg-gray-900 bg-opacity-50 shadow-2xl">
                    <div
                        className="pointer-events-none absolute inset-x-10 -top-24 h-40 opacity-60"
                        aria-hidden="true"
                    />

                    <div className="relative grid gap-10 lg:gap-12 lg:grid-cols-2 p-6 sm:p-8 lg:p-12">
                        <div
                            className="space-y-6 md:space-y-7"
                            data-aos="fade-up"
                        >
                            <div className="space-y-3 text-center lg:text-left max-w-xl mx-auto lg:max-w-none">
                                <p className="text-xs font-semibold tracking-widest text-gray-400">
                                </p>
                                <h1 className="text-2xl sm:text-3xl lg:text-4xl font-semibold text-gray-100">
                                    About Us - Telematics and IoT at scale.
                                </h1>
                                <div className="h-1 w-16 mx-auto lg:mx-0 rounded-full bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />
                            </div>

                            <div className="space-y-4 max-w-xl mx-auto lg:max-w-none text-center lg:text-left">
                                <p className="text-base md:text-lg leading-relaxed text-gray-200">
                                    AGMT was founded to bring fresh technological thinking to an industry constrained by outdated tools and legacy systems. With more than 50 years of combined insurance and risk-management experience, our founders set out to build products that make insurance smarter, fairer and more efficient for both providers and drivers.
                                </p>

                                <p className="text-base md:text-lg leading-relaxed text-gray-200">
                                    We began by pairing low-cost, windscreen-mounted sensing hardware with advanced signal-processing and risk-modelling algorithms. The result was a new approach to understanding real-world driving behaviour - simple to deploy, highly accurate and built for scale.
                                </p>
                            </div>
                        </div>

                        {/* Right: Carousel */}
                        <div
                            className="space-y-5"
                            data-aos="fade-up"
                            data-aos-delay="100"
                        >
                            <div className="rounded-2xl bg-gray-900 bg-opacity-80 p-3 sm:p-4 shadow-xl border border-gray-800 max-w-md mx-auto lg:max-w-none">
                                <Slider {...settings}>
                                    <div className="px-1 sm:px-2">
                                        <img
                                            src={Device5}
                                            alt="AGM device mounted on windscreen"
                                            className="h-48 sm:h-56 lg:h-64 w-full rounded-2xl object-cover shadow-md"
                                        />
                                    </div>
                                    <div className="px-1 sm:px-2">
                                        <img
                                            src={Device}
                                            alt="Telematics and analytics dashboard"
                                            className="h-48 sm:h-56 lg:h-64 w-full rounded-2xl object-cover shadow-md"
                                        />
                                    </div>
                                    <div className="px-1 sm:px-2">
                                        <img
                                            src={Device3}
                                            alt="Close-up of AGM telematics device hardware"
                                            className="h-48 sm:h-56 lg:h-64 w-full rounded-2xl object-cover shadow-md"
                                        />
                                    </div>
                                </Slider>
                            </div>

                            <div className="space-y-3 max-w-xl mx-auto lg:max-w-none">
                                <p className="text-sm md:text-base leading-relaxed text-gray-200 text-center lg:text-left">
                                    As our technology matured, its value extended far beyond traditional telematics. Today, AGMT’s sensing and event detection solutions are used across multiple markets and continents, supporting insurers, fleets and mobility partners through the same principles that defined our earliest products: easy installation, reliable data and cost-efficient performance.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AboutUsIntro;
